import { WeaLocaleProvider,WeaFormItem,WeaInput,WeaTools } from "ecCom";
import { Modal, Radio } from 'antd';
const RadioGroup = Radio.Group;
import { modeForm } from './excelUtil';
import { getContentPath } from '../util/contentPath';
const getLabel = WeaLocaleProvider.getLabel;
import jQuery from 'jquery';

export const showExportMenu = (datas, billsid, modeid,type,comefrom,modeCustomid,dataKey,expcardname,layoutid?,callBack?:Function) => {
    let {isExpOne=''} = expcardname;
    showModal(getLabel(17416, '导出'), (
      <div style={{ minHeight: 100,maxHeight:400,overflow:"scroll", margin: "-30px -50px",textAlign:'center', }}>
            { isExpOne == ''?<RadioGroup ecId={`${this && this.props && this.props.ecId || ''}_RadioGroup@iqno60`}
                onChange={(e) => {
                    localStorage.setItem("cube_export_type", e.target.value);
                }}
                defaultValue={datas[0]['key'] || ""}
            >
                {getRadioGroup(datas)}
            </RadioGroup>:''}
            {expcardname&&expcardname.key=="1"?<WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@hpxels`}  
                style = {datas.length>1?{top:'0px'}:{top:'30px'}}
                label={getLabel(17517, '文件名称')}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                width = {"20%"}
            >
            <div>
             <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@iinc5i`} value={expcardname.showname}  width = {"60%"} onChange={(e) => {
                    localStorage.setItem("cube_export_name", e);
                }}/>
            </div>
            </WeaFormItem>:""}
        </div>
    ), 400, billsid, modeid,layoutid?layoutid:'0',type,comefrom,modeCustomid,dataKey,isExpOne,callBack);
}
const getRadioGroup = (datas = []) => {
    const radioArr: any = [];
    const radioStyle = {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: "10px",
    };
    for (let i = 0; i < datas.length; i++) {
        const item: any = datas[i];
        radioArr.push(<Radio ecId={`${this && this.props && this.props.ecId || ''}_Radio@efgyg3@${i}`} style={radioStyle} key={item.key} value={item.key}>{item.showname}</Radio>)
    }
    return radioArr;
}

const showModal = (title,content, width: number = 400, billsid, modeid,layoutid,type,comefrom="",modeCustomid="",dataKey="",isExpOne="",callBack?:Function) => {
    Modal.info({
        title: <span><div className='wea-browser-single-icon-circle' style={{ background: "#96358a" }}><i className='icon-coms-ModelingEngine' /></div>{title}</span>,
        content: content,
        iconType: "",
        okText: getLabel(33703, "确认"),
        width: width,
        onOk() {
            if(type === "list"){
                if(localStorage.getItem("cube_export_type")=="list"||isExpOne=="1"){   //如果选择的是列表EXCEL列表文件，走老的导出   ,当后台设置了一种导出类型的时候直接导出
                   let excelName = localStorage.getItem("cube_export_name");
                   typeof callBack =="function" && callBack(billsid,excelName);
                   return;
                }
                formPost(getContentPath("/weaver/weaver.formmode.expcard.servlet.ExpCardServer"),{
                    action:"expbatchcard",
                    fileType:localStorage.getItem("cube_export_type"),
                    billids:billsid,
                    modeId:modeid,
                    excelName:localStorage.getItem("cube_export_name"),
                    comefrom:comefrom,
                    modeCustomid:modeCustomid,
                    dataKey:dataKey
                });
            }else if(type==="card"){                
                formPost(getContentPath("/weaver/weaver.formmode.expcard.servlet.ExpCardServer"),{
                    action:"expcard",
                    fileType:localStorage.getItem("cube_export_type"),
                    billid:billsid,
                    layoutid:layoutid,
                    modeId:modeid,
                    doInterface:1
                });
            }
            setTimeout(() => {
                localStorage.setItem("cube_export_type", "");
                localStorage.setItem("cube_export_name", "");
            }, 500)
        },
    });
}

export const  formPost=(URL="", PARAMTERS={})=> {
    //创建form表单
    var temp_form = document.createElement("form");
    temp_form.action = URL;
    //如需打开新窗口，form的target属性要设置为'_blank'
    temp_form.target = "_self";
    temp_form.method = "post";
    temp_form.style.display = "none";
    //添加参数
    for (let item in PARAMTERS) {
        let opt = document.createElement("input");
        opt.name = item;
        opt.value = PARAMTERS[item];
        temp_form.appendChild(opt);
    }
    document.body.appendChild(temp_form);
    //提交数据
    temp_form.submit();
}


//自定义注册事件校验
export const verifyCustomRegisterEvent = (params, callback, registerFnParams={}) => {
    let result = null;
    const opertype = convertOpertype(params);
    const eventArr = opertype === null ? new Array() : modeForm.eventList[opertype];
    //存在注册事件
    if (typeof eventArr === "object" && eventArr.length > 0) {
        let index = 0;
        const executeVerify = () => {
            if (index < eventArr.length) {
                eventArr[index++](() => {
                    executeVerify();
                }, registerFnParams);
            } else {
                result = callback();
            }
        }
        executeVerify();
    } else {
        result = callback();
    }
    return result;
}

const convertOpertype = (params) => {
    if (typeof params === "string")
        return params;
    
    return null;
}

export const showExpendError = (pageExpendResult,href)=>{
    let content:any=[];
    let orihref=href;
    for(let data in pageExpendResult.errordata){
        let pcontent=`${getLabel('512681','执行{0}出错').replace(/\{0\}/,data)},${getLabel('512682','数据id为')}:${pageExpendResult.errordata[data]}`;
        let a=<a href={orihref+"expanderrorid="+pageExpendResult.errordata[data]} target="_blank" style={{marginLeft:10,verticalAlign:'middle'}}>{getLabel('385156','查看列表') }</a>
        content.push(<p style={{textAlign:'center'}}>
            <span title={pcontent} style={{textAlign:'left',width:'300px',overflow:'hidden',textOverflow:'ellipsis',display:'inline-block',whiteSpace:'nowrap',verticalAlign:'middle'}}>{pcontent}</span>
            {a}</p>);
    }
    Modal.error({
        width:500,
        content:content
    })
}

/**
 * 
 * @param pageExpendResult 明细表是否要拖动
 * @param href 
 */
export const isDragula = (card,detail)=>{
    const type=card.base.type=='2'||card.base.type=='1';
    const detailtable=card.getDetailTable(detail);
    const excel = card.modeExcel.getExcel(detail);
    const { isPagination = false } = excel.detailProps;
    const isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
    let result = type&&detailtable.isOpenCustomOrder&&!isNeedPagination;
    return result;
}

/**
 * 是否来自门户菜单点击
 */
export const isFromProtal=()=>{
    let url=WeaTools.WindowFunc.getTop().location.href;
    if(url.indexOf('/spa/cube/')>0){
        return false;
    }
    return true;
}


//滚动过程中控制表头固定
export const fixedDetailHead = () =>{
    const container = jQuery('.cube-card-form-content');
    const conOffsetTop = container.offset().top;
    container.find(".excelDetailTableDiv").each(function(){
        const groupid = jQuery(this).attr("data-groupid");
        const detailFixedDiv = jQuery(this).find("[class^=excelDetailFixedHead]");
        const detailTable = jQuery("#oTable"+groupid);
        const lockedBtn = jQuery(this).parent().find(".cube-detail-locked-btnrow");
        const existLockedBtn = lockedBtn.length > 0;
        let detailHeight = detailTable.height();
        const unFixedFn = () =>{
            if(existLockedBtn) {
                lockedBtn.removeClass("cube-detail-locked-btnrow-fixed");
                calculateDetailAreaStyle(jQuery('.cube-card-excelMainTable-wrapper'));
            }
            detailFixedDiv.hide();
        }
        if(detailHeight < 300){     //此if不能后移，会导致部分ios滑动闪屏，why...
            unFixedFn();
            return true;
        }
        let detailOffsetTop = detailTable.offset().top;
        let fixedHeadHeight = detailFixedDiv.height();
        let lockedBtnHeight = 0;
        if(existLockedBtn){
            lockedBtnHeight = lockedBtn.height();
            detailHeight += lockedBtnHeight;
            fixedHeadHeight += lockedBtnHeight;
        }
        const fixedFn = () =>{
            if(existLockedBtn){
                lockedBtn.addClass("cube-detail-locked-btnrow-fixed");
                lockedBtn.find(".cube-detail-locked-btnrow-content").css("top", conOffsetTop);
            }
            detailFixedDiv.css("top", conOffsetTop+lockedBtnHeight).show();
            syncFixedHeadWidth(groupid);
            syncDetailScrollXPosition(groupid);
        }
        //冻结表头，明细表最低要求200px高度
        //console.log("groupid",groupid,"detailHeight",detailHeight,"detailOffsetTop",detailOffsetTop,"conOffsetTop",conOffsetTop,"fixedHeadHeight",fixedHeadHeight);
        if(detailOffsetTop < conOffsetTop && detailOffsetTop + detailHeight >= fixedHeadHeight + conOffsetTop){
            fixedFn();
        }else{
            unFixedFn();
        }
    });
}


//同步列宽到固定表头,列锁定情况仅同步滚动区域
export const syncFixedHeadWidth = (groupid) => {
    try{
        const detailTable = jQuery("#oTable"+groupid);
        const detailFixedTable = jQuery("#oTable"+groupid+"_head");
        const detailFixedDiv = detailFixedTable.parent();
        if(!detailFixedDiv.is(":hidden")){
            detailFixedTable.width(detailTable.width());
            // const fixedWidthRow = detailFixedTable.find("tr.detailControlWidth");
            // detailTable.find("tr.detailControlWidth").children().each(function(index){
            //     fixedWidthRow.find("td:eq("+index+")").css("width", jQuery(this).width()+"px");
            // });
            let topRowWidth = detailFixedDiv.parent().width();
            const wrapperWidth = detailFixedDiv.parents('.cube-card-excelMainTable-wrapper').width();
            /* 解决固定表头宽度问题，谁小取谁 */
            if (wrapperWidth<763) {
                topRowWidth = wrapperWidth;
                detailFixedDiv.css({"margin-left":"-1px","border-left":"1px solid #e7f3fc","border-right":"1px solid #e7f3fc"});
            } else {
                detailFixedDiv.css({"margin-left":"0px","border-left":"none","border-right":"none"});
            }
            detailFixedDiv.css("width", topRowWidth);
            calculateDetailAreaStyle(jQuery('.cube-card-excelMainTable-wrapper'));
        }
    }catch(e){}
}

//同步横向滚动条位置到固定表头
export const syncDetailScrollXPosition = (groupid) => {
    try{
        const detailArea = (window as any).jQuery("#dTableArea_"+groupid);
        const cardScrollLeft = jQuery('.cube-card-excelMainTable-wrapper').scrollLeft();
        const scrollLeft = detailArea.find(".excelDetailTable_wrap").scrollLeft() + cardScrollLeft;
        detailArea.find(".excelDetailFixedHead").scrollLeft(scrollLeft);
        
        detailArea.find(".excelDetailFixedHead_locked").css("width", detailArea.find("#oTable"+groupid+"_locked").width() - cardScrollLeft);
        detailArea.find("#oTable"+groupid+"_head_locked").css('marginLeft', 0-cardScrollLeft);
    }catch(e){}
}


//计算指定区域下明细表样式，兼容标签页内嵌明细情况
export const calculateDetailAreaStyle = (area=jQuery()) =>{
    area.find(".cube-detail").each(function(){
        if(!jQuery(this).is(":visible"))
            return true;
        // const excelDetailTableDiv = jQuery(this).find(".excelDetailTableDiv");
        // const groupid = parseInt(excelDetailTableDiv.attr("data-groupid"));
        // const swapWidth = excelDetailTableDiv.width();
        // const dataAreaWidth = excelDetailTableDiv.find("#oTable"+groupid).width();
        // // const lockedAreaWidth = excelDetailTableDiv.find("#oTable"+groupid+"_locked") && excelDetailTableDiv.find("#oTable"+groupid+"_locked").width() || 0;
        // const detailObj = detailMap.get("detail_"+(groupid+1));
        // if(swapWidth >=dataAreaWidth ){     //宽度不足，横向滚动条失效
        //     detailObj.controlVariableMap("forceDisabledScrollX", true);
        // }
        const lockedBtnRow = jQuery(this).find(".cube-detail-locked-btnrow");
        if(lockedBtnRow.length > 0){
            const topRowHeight = lockedBtnRow.height();
            let topRowWidth = lockedBtnRow.parent().width();
            const wrapperWidth = lockedBtnRow.parents('.cube-card-excelMainTable-wrapper').width();
            const isFixed = lockedBtnRow.hasClass('cube-detail-locked-btnrow-fixed');
            /* 解决固定表头宽度问题，谁小取谁 */
            if (isFixed && wrapperWidth<763) {
                topRowWidth = wrapperWidth;
                lockedBtnRow.find(".cube-detail-locked-btnrow-content").css('margin-left','-1px'); // 固定表头错位问题
            } else {
                lockedBtnRow.find(".cube-detail-locked-btnrow-content").css('margin-left','0px'); // 固定表头错位问题
            }
            lockedBtnRow.find(".cube-detail-locked-btnrow-content").width(topRowWidth);
            lockedBtnRow.find(".cube-detail-locked-btnrow-placeholder").height(topRowHeight);
        }
        // syncLockedForDidMount(groupid);
    });
}

export const importantParamRange = ["token", "billid","type","modeId","formId","customid","layoutid", "isFormMode", "iscreate", "src",
    "currentLayoutId","pageexpandid","JSONStr","btntype","issystemflag","oldmodedatastatus"
];

//人力资源条件数据处理 sharetype_relatedshare_rolelevel_seclevel_canDownload
export const spellResourceCondition = (datas) => {
    if (datas) {
        let value: string[] = [];
        datas.map((item) => {
            let candownload=item.canDownload=='是'?'1':'0';
            if (item.sharetype == "1") {
                value.push(`1_${item.relatedshare}_0_0_${candownload}`);
            } else if (item.sharetype == "2" || item.sharetype == "3") {
                value.push(`${item.sharetype}_${item.relatedshare}_0_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "4") {
                value.push(`4_${item.relatedshare}_${item.rolelevel}_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "5") {
                value.push(`5_0_0_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value.push(`6_${item.relatedshare}_0_2|@|2_${candownload}`);
                } else {
                    value.push(`6_${item.relatedshare}_0_${item.joblevel}|@|${item.jobfield}_${candownload}`)
                }
            }
        });
        return value.join('~');
    }
    return '';
}

export const unSpellResourceCondition = (str = '') => {
    let array = str.split('~');
    return array.map(item => {
        const obj: any = {};
        const valArr = item.split('_');
        const sharetype = valArr[0];
        obj.sharetype = sharetype;
        if (sharetype == '1') {
            obj.relatedshare = valArr[1];
        } else if (sharetype == "2" || sharetype == "3") {
            obj.relatedshare = valArr[1];
            obj.seclevel = valArr[3].replace('|@|', '-');
        } else if (sharetype == "4") {
            obj.relatedshare = valArr[1];
            obj.rolelevel = valArr[2];

            if(valArr[2]=='0'){
                obj.rolelevelspan = getLabel(27511, '部门')
            }
            if(valArr[2]=='1'){
                obj.rolelevelspan = getLabel(33553, '分部')
            }
            if(valArr[2]=='2'){
                obj.rolelevelspan = getLabel(140, '总部')
            }
            obj.seclevel = valArr[3].replace('|@|', '-');
        } else if (sharetype == "5") {
            obj.seclevel = valArr[3].replace('|@|', '-');
        } else if (sharetype == "6") {
            obj.relatedshare = valArr[1];
            if (valArr[3] == '2|@|2') {
                obj.joblevel = '2';
            } else {
                var temp = valArr[3].split('|@|');
                obj.joblevel = temp[0];
                obj.jobfield = temp[1];
            }
        }
        obj.canDownload = valArr[4] && valArr[4] == '1' ? getLabel(163, '是') : getLabel(30587, '否');
        return obj;
    });
};

const getTypeName = sharetype => {
    const TYPEFLECT = {
        '1': getLabel(30042, '人员'),
        '2': getLabel(33553, '分部'),
        '3': getLabel(27511, '部门'),
        '4': getLabel(122, '角色'),
        '5': getLabel(1340, '所有人'),
        '6': getLabel(6086, '岗位'),
    };
    return TYPEFLECT[sharetype] || "";
};

export const getReConditionObj = (val,name) => {
    const sharetype = val.sharetype;
    if(sharetype == '5'){
        name = getLabel(1340, '所有人')
    }else{
        let nametemp = name.match(/\((.*)\)/);
        if(nametemp && nametemp.length>1){
            name = nametemp[1];
        }
    }
    let valueObj:any = {
        key: val.relatedshare || "",
        id: val.relatedshare || "",
        name:name,
        relatedshare: val.relatedshare || "",
        relatedsharespan:name,
        relatedshareurl:  "/spa/hrm/index_mobx.html#/main/hrm/card/cardInfo/" + val.relatedshare || '',
        sharetype: sharetype || "",
        sharetypespan: getTypeName(sharetype),
        canDownload:val.canDownload,
        seclevel: val.seclevel || '',
    }
    if(sharetype == '4'){
        valueObj = {
            ...valueObj,
            rolelevel: val.rolelevel || '',
            rolelevelspan: val.rolelevelspan || '',
            relatedshareurl :"/hrm/roles/HrmRolesEdit.jsp?id="+ val.relatedshare || ""
        }
    }else if(sharetype == '5'){
        delete valueObj.relatedshare;
        delete valueObj.relatedsharespan;
        delete valueObj.relatedshareurl;
    }else if(sharetype == '6'){
        let nameJob:any = [];
        if(name.indexOf('/')>-1){
            nameJob = name.split('/')
        }
        let oterInfo = {};
        if(val.joblevel !== '2'){
            try {
                oterInfo = {
                    jobfield: val.jobfield,
                    jobfieldspan: nameJob[1].match(/\((.*)\)/)[1].trim().split(" ").join(","),
                }
            } catch (error) {}
        }
        let jobSpan = [getLabel(500670, '指定部门'),getLabel(19437, '指定分部'),getLabel(140, '总部')];
        valueObj = {
            ...valueObj,
            ...oterInfo,
            name: nameJob.length>0 ? nameJob[0] : name,
            relatedsharespan: nameJob.length>0 ? nameJob[0] : name,
            joblevel: val.joblevel,
            joblevelspan: jobSpan[val.joblevel],
        }
    }
    return valueObj;
}

export const getDefaultValueSpan = (valuespan,value) => {
    try {
        return valuespan.replace(/<\/?[^>]*>/g,'')
    } catch (error) {
        return valuespan
    }
}

/**
 * @description 自动定位到showError的报错信息位置
 * */
export const toWrongLocation = () => {
    try {
        setTimeout(() => {
            jQuery('.wea-error.has-error .error-tip').eq(0).attr('hidefocus', true).attr('tabIndex', '0').focus().removeAttr('tabIndex')
        }, 0)
    } catch (err) {
    }
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/util/cubeUtil.tsx